import { render, staticRenderFns } from "./StudySetupCard.vue?vue&type=template&id=7ed6b8f6&scoped=true&"
import script from "./StudySetupCard.vue?vue&type=script&lang=js&"
export * from "./StudySetupCard.vue?vue&type=script&lang=js&"
import style0 from "./StudySetupCard.vue?vue&type=style&index=0&id=7ed6b8f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed6b8f6",
  null
  
)

export default component.exports